/*
 * This file contains the routes for dedicated retail partner pages
 * Includes a default result list landing page and a product detail page
 * Example: /p/partner-slug, /p/partner-slug/product/1234
 */

export default {
  path: '/p/:partnerSlug',
  alias: ['/app/p/:partnerSlug'],
  component: () => import('src/layouts/shared/ShoppingLayout.vue'),
  children: [
    {
      path: '',
      name: 'PartnerHome',
      meta: { bodyClass: 'partner-home-page' },
      component: () => import('src/pages/shared/partner/PartnerHomePage.vue'),
    },
    {
      path: 'search',
      name: 'PartnerSearch',
      meta: { bodyClass: 'partner-search-page' },
      component: () => import('src/pages/shared/partner/PartnerSearchPage.vue'),
    },
    {
      path: 'product/:productId',
      name: 'PartnerProduct',
      meta: { bodyClass: 'partner-product-page' },
      component: () => import('pages/shared/partner/PartnerProductDetailPage.vue'),
    },
  ],
}
